import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'

import HTMLRenderer from 'react-html-renderer'
const api = new Api()

type Props = {
  showRegisterModal: boolean
  handleCloseRegisterModal: any
}

const RegisterContent: FC<Props> = ({showRegisterModal, handleCloseRegisterModal}) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [errors, setErrors] = useState({})
  const [dataInfo, setDataInfo] = useState<any>({})
  const [registrationClosed, setRegistrationClosed] = useState(false)

  useEffect(() => {
    setShowModal(showRegisterModal)
    const storedData = localStorage.getItem('dataInfo')

    if (storedData && storedData !== 'undefined') {
      setDataInfo(JSON.parse(storedData))
    } else {
      getMasterTable()
    }

    checkRegistrationDeadline()
  }, [showRegisterModal])

  const checkRegistrationDeadline = () => {
    api
      .getThemeList()
      .then((themeResponse: any) => {
        let themeList = []
        if (themeResponse.data?.data?.data) {
          themeList = themeResponse.data.data.data
        } else if (themeResponse.data?.data && Array.isArray(themeResponse.data.data)) {
          themeList = themeResponse.data.data
        } else if (Array.isArray(themeResponse.data)) {
          themeList = themeResponse.data
        }

        if (themeList.length > 0) {
          const theme = themeList[0]

          api
            .getTimeServer()
            .then((timeResponse: any) => {
              const serverTime = timeResponse.data?.server_time
              const endDate = theme.tanggal_akhir

              if (endDate && serverTime) {
                const now = new Date(serverTime)
                const deadline = new Date(endDate)
                setRegistrationClosed(now > deadline)
              }
            })
            .catch((error: any) => {
              console.error('Error fetching server time:', error)
            })
        }
      })
      .catch((error: any) => {
        console.error('Error fetching theme list:', error)
      })
  }

  const handleCloseModal = () => {
    setShowModal(false)
    handleCloseRegisterModal(false)
  }

  const handleRegister = () => {
    navigate('/my-pana')
  }

  const handleSubmitRegister = () => {
    if (registrationClosed) {
      toast.error('Periode pendaftaran telah berakhir')
      return
    }

    setLoading(true)
    api
      .registerPana({step: 0})
      .then((response: any) => {
        setLoading(false)
        handleRegister()
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  const getMasterTable = () => {
    setLoading(true)
    api
      .getMasterTable({tipe: 'modal_panduan_pana', is_active: 1})
      .then((response: any) => {
        setLoading(false)
        const {data} = response?.data?.data
        setDataInfo(data[0])
        localStorage.setItem('dataInfo', JSON.stringify(data[0]))
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  return (
    <Modal show={showModal} centered size='lg' onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <p className='h6 px-3'>Program Alumni Pejuang Digital</p>
      </Modal.Header>
      <div className='p-10'>
        <p>
          Program kolaborasi <strong>Kemendikdasmen</strong> dan <strong>LPDP</strong> untuk mempercepat 
          digitalisasi pembelajaran di sekolah wilayah 3T dan Daerah Khusus. Alumni LPDP berperan sebagai 
          Pejuang Digital yang mendampingi guru selama <strong>3 bulan</strong> secara intensif.
        </p>

        <img
          src={require('../../assets/img/register-image.png')}
          alt='PANA'
          className='mt-5'
          style={{height: 'auto', width: '100%'}}
        />

        <div className='mt-10'>
          <p className='fw-bold'>Sebelum Mendaftar:</p>
          <p>Pastikan Anda memahami dan sudah menyiapkan persyaratan berikut:</p>

          <p className='fw-bold mt-5'>1. Siapa yang Bisa Mendaftar?</p>
          <ul>
            <li>Alumni LPDP yang sudah mengikuti Persiapan Keberangkatan (PK)</li>
            <li>Telah memperbarui data di portal Talenta LPDP</li>
          </ul>

          <p className='fw-bold mt-5'>2. Skema Pendaftaran:</p>
          <ul>
            <li><strong>Individu:</strong> Mendaftar sendiri.</li>
          </ul>

          <p className='fw-bold mt-5'>3. Fokus Pendampingan:</p>
          <ul>
            <li>Pemanfaatan Papan Interaktif Digital (PID)</li>
            <li>Penggunaan bahan ajar digital</li>
            <li>Penerapan pembelajaran interaktif</li>
            <li>Peningkatan kompetensi guru</li>
            <li>Penguatan manajerial sekolah</li>
          </ul>

          <p className='fw-bold mt-5'>4. Wilayah Sasaran:</p>
          <ul>
            <li>Kabupaten Sumedang (Jawa Barat)</li>
            <li>Kabupaten Kupang (Nusa Tenggara Timur)</li>
            <li>Kabupaten Halmahera Utara (Maluku Utara)</li>
            <li>Kabupaten Merauke (Papua Selatan)</li>
          </ul>

          <p className='fw-bold mt-5'>5. Dokumen Wajib:</p>
          <ul>
            <li>Menulis Essay sesuai dengan topik yang di tentukan</li>
            <li>Surat keterangan sehat</li>
            <li>Surat izin dari tempat kerja (jika masih bekerja)</li>
          </ul>
        </div>

        {registrationClosed && (
          <div className='alert alert-warning mt-5' role='alert'>
            <div className='d-flex align-items-start gap-2'>
              <i className='bi bi-exclamation-triangle-fill fs-5 mt-1 flex-shrink-0'></i>
              <div>
                <strong className='d-block mb-1'>Pendaftaran Ditutup</strong>
                <p className='mb-0' style={{fontSize: '0.9rem'}}>
                  Periode pendaftaran telah berakhir. Anda tidak dapat mendaftar saat ini.
                </p>
              </div>
            </div>
          </div>
        )}

        <button
          className='btn btn-primary btn-sm w-100 mt-10'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          onClick={handleSubmitRegister}
          disabled={loading || registrationClosed}
        >
          {loading ? 'Loading...' : registrationClosed ? 'Pendaftaran Ditutup' : 'Daftar Sekarang!'}
        </button>
      </div>
    </Modal>
  )
}

const RegisterModal: FC<Props> = ({showRegisterModal, handleCloseRegisterModal}) => {
  return (
    <RegisterContent
      showRegisterModal={showRegisterModal}
      handleCloseRegisterModal={handleCloseRegisterModal}
    />
  )
}

export default RegisterModal
